import { render } from "./MyReviews.vue?vue&type=template&id=0dabe21f&scoped=true"
import script from "./MyReviews.vue?vue&type=script&lang=js"
export * from "./MyReviews.vue?vue&type=script&lang=js"

import "./MyReviews.vue?vue&type=style&index=0&id=0dabe21f&lang=scss&scoped=true"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dabe21f"]])

export default __exports__